import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import LoginForm, { loginForm } from '../../components/auth/LoginForm';
import { Alert, Box, Card, Container, Grid, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from '../routes';
import { useDispatch } from 'react-redux';
import { setAuth } from '../../store/reducers/user.reducer';
import { useAuth } from '../../hooks/useAuth';
import { ApiError } from '../../shared/types/apiError.type';
import Errors from '../../components/global/Errors';
import LanguageSelector from '../../components/global/LanguageSelector';
import { useLocales } from '../../hooks/useLocales';
import { languages } from '../../enums/languages.enum';
import { toast } from 'react-toastify';
import { useFirstLogin } from '../../context/firstLoginContext';

function Login() {
  const { t } = useTranslation();
  const { login, isLoading, isError, error } = useAuth()
  const navigation = useNavigate()
  const { updateLang, currentLang } = useLocales()
  const err = error?.response?.data as ApiError
  const { toggleFirstTime } = useFirstLogin()
  // Get the location object
  const location = useLocation();

  // Retrieve the passed state
  const nextLocation = location.state?.nextLocation;


  const handleLogin = async (data: loginForm) => {
    try {

      let result = await login(data)

      //Redirect to next location
      if (nextLocation) {
        navigation(nextLocation)
      }

      if (result?.first_web_login) {
        toggleFirstTime(true)
      }



    } catch (error: any) {
      let errorData = error.response?.data as ApiError


      if (errorData?.code === 409) {
        navigation(routes.AUTH_ROUTES.EMAIL_SENT, { state: { email: data.email } })
      }
      if (errorData?.code === 500) {
        toast(t('error:generic'), { type: 'error' })

      }
    }
  }

  return (
    <Box height={'100vh'}>
      <Container maxWidth="lg" sx={{ pt: 2, display: 'flex', justifyContent: 'end' }}>
        <LanguageSelector
          langs={languages}
          onSelect={(lang) => { updateLang(lang) }}
          currentLang={currentLang}
        />
      </Container>
      <Grid container sx={{ mt: 8 }} >

        <Grid item md={12} sm={12} xs={12} display={'flex'} justifyContent={'center'} alignItems={'center'}  >
          <Container maxWidth="xs" >

            <Errors isError={isError} error={err}></Errors>
            <LoginForm
              isLoading={isLoading}
              onSubmitLogin={handleLogin}
              onRegisterClicked={() => navigation(routes.AUTH_ROUTES.REGISTER)}
              onForgotPasswordClicked={() => navigation(routes.AUTH_ROUTES.FORGOT_PASSWORD)}
            ></LoginForm>
          </Container>
        </Grid>

      </Grid>
    </Box>
  )
}

export default Login